'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fContactService = function () {
  function fContactService($http) {
    _classCallCheck(this, fContactService);

    this.prefix = IFEIS_API_URI + '/api/contact';
    this.$http = $http;
  }

  _createClass(fContactService, [{
    key: 'email',
    value: function email(msg) {
      return this.$http.post(this.prefix, msg);
    }
  }]);

  return fContactService;
}();

exports.default = angular.module('ifeis.contact', []).service('fContactService', fContactService);


//////////////////
// WEBPACK FOOTER
// ./contact/index.js
// module id = 207
// module chunks = 0